"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
var react_1 = require("react");
var Picture_1 = __importDefault(require("../Picture"));
var useWebP_1 = __importDefault(require("../Picture/useWebP"));
function ImagesLoader(_a) {
    var images = _a.images, onImagesLoad = _a.onImagesLoad;
    var webp = (0, useWebP_1.default)();
    var loadCount = (0, react_1.useRef)(0);
    var onLoad = (0, react_1.useCallback)(function () {
        loadCount.current++;
        if (onImagesLoad && loadCount.current === images.length) {
            onImagesLoad();
        }
    }, [onImagesLoad]);
    if (webp === undefined)
        return null;
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: images.map(function (image, index) { return (0, jsx_runtime_1.jsx)(Picture_1.default, { src: image, alt: "", style: { display: 'none' }, onLoad: onLoad }, index); }) }));
}
exports.default = ImagesLoader;
//# sourceMappingURL=ImagesLoader.js.map